import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
export const defaultOccFilmDisplayText = {
    nowShowingLabel: 'Now showing',
    comingSoonLabel: 'Coming soon',
    advanceBookingLabel: 'Advance bookings',
    preBookNowLabel: 'Pre-book now',
    sponsoredLabel: 'Sponsored',
    runtimeFormat: '${hours}h ${minutes}m',
    addToWatchlistButtonLabel: 'Add to watchlist',
    removeFromWatchlistButtonLabel: 'Remove from watchlist',
    failedToAddFilmToWatchlistTitle: 'Failed to add to watchlist',
    failedToAddFilmToWatchlistMessage: 'Sorry, ${filmTitle} could not be added to your watchlist. Please try again later.',
    failedToRemoveFilmFromWatchlistTitle: 'Failed to remove from watchlist',
    failedToRemoveFilmFromWatchlistMessage: 'Sorry, ${filmTitle} could not be removed from your watchlist. Please try again later.'
};
export const occFilmDisplayTextValidator = Validator.object({
    nowShowingLabel: nonEmptyStringValidator,
    comingSoonLabel: nonEmptyStringValidator,
    advanceBookingLabel: nonEmptyStringValidator,
    preBookNowLabel: nonEmptyStringValidator,
    sponsoredLabel: nonEmptyStringValidator,
    runtimeFormat: nonEmptyStringValidator,
    addToWatchlistButtonLabel: nonEmptyStringValidator,
    removeFromWatchlistButtonLabel: nonEmptyStringValidator,
    failedToAddFilmToWatchlistTitle: nonEmptyStringValidator,
    failedToAddFilmToWatchlistMessage: nonEmptyStringValidator,
    failedToRemoveFilmFromWatchlistTitle: nonEmptyStringValidator,
    failedToRemoveFilmFromWatchlistMessage: nonEmptyStringValidator
});
